module.exports = __webpack_public_path__ + "12060bc9b52328b61f651d27cb50693b.png";